var nameMap = {
  'Afghanistan': '阿富汗',
  'Albania': '阿尔巴尼亚',
  'Algeria': '阿尔及利亚',
  'Andorra': '安道尔',
  'Angola': '安哥拉',
  'Antarctica': '南极洲',
  'Antigua and Barbuda': '安提瓜和巴布达',
  'Argentina': '阿根廷',
  'Armenia': '亚美尼亚',
  'Australia': '澳大利亚',
  'Austria': '奥地利',
  'Azerbaijan': '阿塞拜疆',
  'The Bahamas': '巴哈马',
  'Bahrain': '巴林',
  'Bangladesh': '孟加拉国',
  'Barbados': '巴巴多斯',
  'Belarus': '白俄罗斯',
  'Belgium': '比利时',
  'Belize': '伯利兹',
  'Benin': '贝宁',
  'Bermuda': '百慕大',
  'Bhutan': '不丹',
  'Bolivia': '玻利维亚',
  'Bosnia and Herzegovina': '波斯尼亚和黑塞哥维那',
  'Botswana': '博茨瓦纳',
  'Brazil': '巴西',
  'Brunei': '文莱',
  'Bulgaria': '保加利亚',
  'Burkina Faso': '布基纳法索',
  'Burundi': '布隆迪',
  'Cambodia': '柬埔寨',
  'Cameroon': '喀麦隆',
  'Canada': '加拿大',
  'Cape Verde': '佛得角',
  'Central African Republic': '中非共和国',
  'Chad': '乍得',
  'Chile': '智利',
  'China': '中国',
  'Colombia': '哥伦比亚',
  'Comoros': '科摩罗',
  'Republic of the Congo': '刚果共和国',
  'Costa Rica': '哥斯达黎加',
  'Croatia': '克罗地亚',
  'Cuba': '古巴',
  'Cyprus': '塞浦路斯',
  'Czech Republic': '捷克共和国',
  'Denmark': '丹麦',
  'Djibouti': '吉布提',
  'Dominica': '多米尼加',
  'Dominican Republic': '多明尼加共和国',
  'Ecuador': '厄瓜多尔',
  'Egypt': '埃及',
  'El Salvador': '萨尔瓦多',
  'Equatorial Guinea': '赤道几内亚',
  'Eritrea': '厄立特里亚',
  'Estonia': '爱沙尼亚',
  'Ethiopia': '埃塞俄比亚',
  'Falkland Islands': '福克兰群岛',
  'Faroe Islands': '法罗群岛',
  'Fiji': '斐济',
  'Finland': '芬兰',
  'France': '法国',
  'French Guiana': '法属圭亚那',
  'French Southern and Antarctic Lands': '法属南半球和南极领地',
  'Gabon': '加蓬',
  'Gambia': '冈比亚',
  'Gaza Strip': '加沙',
  'Georgia': '格鲁吉亚',
  'Germany': '德国',
  'Ghana': '加纳',
  'Greece': '希腊',
  'Greenland': '格陵兰',
  'Grenada': '格林纳达',
  'Guadeloupe': '瓜德罗普',
  'Guatemala': '危地马拉',
  'Guinea': '几内亚',
  'Guinea Bissau': '几内亚比绍',
  'Guyana': '圭亚那',
  'Haiti': '海地',
  'Honduras': '洪都拉斯',
  'Hong Kong': '中国香港',
  'Hungary': '匈牙利',
  'Iceland': '冰岛',
  'India': '印度',
  'Indonesia': '印尼',
  'Iran': '伊朗',
  'Iraq': '伊拉克',
  'Iraq-Saudi Arabia Neutral Zone': '伊拉克阿拉伯中立区',
  'Ireland': '爱尔兰',
  'Isle of Man': '马恩岛',
  'Israel': '以色列',
  'Italy': '意大利',
  'Ivory Coast': '科特迪瓦',
  'Jamaica': '牙买加',
  'Jan Mayen': '扬马延岛',
  'Japan': '日本',
  'Jordan': '约旦',
  'Kazakhstan': '哈萨克斯坦',
  'Kenya': '肯尼亚',
  'Kerguelen': '凯尔盖朗群岛',
  'Kiribati': '基里巴斯',
  'North Korea': '北朝鲜',
  'South Korea': '韩国',
  'Kuwait': '科威特',
  'Kyrgyzstan': '吉尔吉斯斯坦',
  'Laos': '老挝',
  'Latvia': '拉脱维亚',
  'Lebanon': '黎巴嫩',
  'Lesotho': '莱索托',
  'Liberia': '利比里亚',
  'Libya': '利比亚',
  'Liechtenstein': '列支敦士登',
  'Lithuania': '立陶宛',
  'Luxembourg': '卢森堡',
  'Macau': '澳门',
  'Macedonia': '马其顿',
  'Madagascar': '马达加斯加',
  'Malawi': '马拉维',
  'Malaysia': '马来西亚',
  'Maldives': '马尔代夫',
  'Mali': '马里',
  'Malta': '马耳他',
  'Martinique': '马提尼克',
  'Mauritania': '毛里塔尼亚',
  'Mauritius': '毛里求斯',
  'Mexico': '墨西哥',
  'Moldova': '摩尔多瓦',
  'Monaco': '摩纳哥',
  'Mongolia': '蒙古',
  'Morocco': '摩洛哥',
  'Mozambique': '莫桑比克',
  'Myanmar': '缅甸',
  'Namibia': '纳米比亚',
  'Nepal': '尼泊尔',
  'Netherlands': '荷兰',
  'New Caledonia': '新喀里多尼亚',
  'New Zealand': '新西兰',
  'Nicaragua': '尼加拉瓜',
  'Niger': '尼日尔',
  'Nigeria': '尼日利亚',
  'Northern Mariana Islands': '北马里亚纳群岛',
  'Norway': '挪威',
  'Oman': '阿曼',
  'Pakistan': '巴基斯坦',
  'Panama': '巴拿马',
  'Papua New Guinea': '巴布亚新几内亚',
  'Paraguay': '巴拉圭',
  'Peru': '秘鲁',
  'Philippines': '菲律宾',
  'Poland': '波兰',
  'Portugal': '葡萄牙',
  'Puerto Rico': '波多黎各',
  'Qatar': '卡塔尔',
  'Reunion': '留尼旺岛',
  'Romania': '罗马尼亚',
  'Russia': '俄罗斯',
  'Rwanda': '卢旺达',
  'San Marino': '圣马力诺',
  'Sao Tome and Principe': '圣多美和普林西比',
  'Saudi Arabia': '沙特阿拉伯',
  'Senegal': '塞内加尔',
  'Seychelles': '塞舌尔',
  'Sierra Leone': '塞拉利昂',
  'Singapore': '新加坡',
  'Slovakia': '斯洛伐克',
  'Slovenia': '斯洛文尼亚',
  'Solomon Islands': '所罗门群岛',
  'Somalia': '索马里',
  'South Africa': '南非',
  'Spain': '西班牙',
  'Sri Lanka': '斯里兰卡',
  'St. Christopher-Nevis': '圣',
  'St. Lucia': '圣露西亚',
  'St. Vincent and the Grenadines': '圣文森特和格林纳丁斯',
  'Sudan': '苏丹',
  'Suriname': '苏里南',
  'Svalbard': '斯瓦尔巴特群岛',
  'Swaziland': '斯威士兰',
  'Sweden': '瑞典',
  'Switzerland': '瑞士',
  'Syria': '叙利亚',
  'Taiwan': '台湾',
  'Tajikistan': '塔吉克斯坦',
  'United Republic of Tanzania': '坦桑尼亚',
  'Thailand': '泰国',
  'Togo': '多哥',
  'Tonga': '汤加',
  'Trinidad and Tobago': '特里尼达和多巴哥',
  'Tunisia': '突尼斯',
  'Turkey': '土耳其',
  'Turkmenistan': '土库曼斯坦',
  'Turks and Caicos Islands': '特克斯和凯科斯群岛',
  'Uganda': '乌干达',
  'Ukraine': '乌克兰',
  'United Arab Emirates': '阿联酋',
  'United Kingdom': '英国',
  'United States': '美国',
  'Uruguay': '乌拉圭',
  'Uzbekistan': '乌兹别克斯坦',
  'Vanuatu': '瓦努阿图',
  'Venezuela': '委内瑞拉',
  'Vietnam': '越南',
  'Western Sahara': '西撒哈拉',
  'Western Samoa': '西萨摩亚',
  'Yemen': '也门',
  'Yugoslavia': '南斯拉夫',
  'Democratic Republic of the Congo': '刚果民主共和国',
  'Zambia': '赞比亚',
  'Zimbabwe': '津巴布韦',
  'South Sudan': '南苏丹',
  'Somaliland': '索马里兰',
  'Montenegro': '黑山',
  'Kosovo': '科索沃',
  'Republic of Serbia': '塞尔维亚',
};

var option = null;

export function initCharts(Businessmap, worlddata, nameMap, min, max) {
  // console.log('初始化世界地图数据:', worlddata);
  Businessmap.clear();

  // ========== 中国数据特殊处理 ==========
  var dataList = Array.isArray(worlddata) ? worlddata : [];

  // 查找三个地区的数据
  var mainlandItem = null;
  var hkItem = null;
  var twItem = null;

  for (var i = 0; i < dataList.length; i++) {
    var item = dataList[i];
    if (!item || !item.Name) continue;

    var name = item.Name;
    if (name === '中国' || name === '中国内地') {
      mainlandItem = item;
    } else if (name === '中国香港' || name === '中国香港特区') {
      hkItem = item;
    } else if (name === '台湾' || name === '中国台湾地区' || name === '中国台湾') {
      twItem = item;
    }
  }

  // 计算颜色映射用的最大值
  var values = [];
  if (mainlandItem && mainlandItem.factValue !== undefined && mainlandItem.factValue !== null) {
    values.push(mainlandItem.factValue);
  }
  if (hkItem && hkItem.factValue !== undefined && hkItem.factValue !== null) {
    values.push(hkItem.factValue);
  }
  if (twItem && twItem.factValue !== undefined && twItem.factValue !== null) {
    values.push(twItem.factValue);
  }

  var maxChinaValue = values.length > 0 ? Math.max.apply(null, values) : null;

  // 构建 tooltip 数据
  var chinaTooltipData = {
    mainland: (mainlandItem && mainlandItem.factValue !== undefined && mainlandItem.factValue !== null) ? mainlandItem.factValue : null,
    hongkong: (hkItem && hkItem.factValue !== undefined && hkItem.factValue !== null) ? hkItem.factValue : null,
    taiwan: (twItem && twItem.factValue !== undefined && twItem.factValue !== null) ? twItem.factValue : null,
    hasMainland: !!mainlandItem
  };

  var chinaProcessed = false;
  // =====================================

  // 转换数据格式
  var formattedData = [];
  for (var j = 0; j < dataList.length; j++) {
    var dataItem = dataList[j];
    if (!dataItem || !dataItem.Name) continue;

    var itemName = dataItem.Name;

    // 跳过香港和台湾（合并到中国）
    if (itemName === '中国香港' || itemName === '中国香港特区' ||
      itemName === '台湾' || itemName === '中国台湾地区' || itemName === '中国台湾') {
      continue;
    }

    // 中国：用最大值作为颜色，附加 tooltip 数据
    if (itemName === '中国' || itemName === '中国内地') {
      chinaProcessed = true;
      formattedData.push({
        name: itemName,
        value: maxChinaValue !== null ? maxChinaValue : dataItem.factValue,
        _chinaData: chinaTooltipData
      });
    } else {
      // 其他国家：保持原样，携带 countryid 用于跳转
      var cid = dataItem.CountryId !== undefined ? dataItem.CountryId :
                (dataItem.countryid !== undefined ? dataItem.countryid :
                (dataItem.id !== undefined ? dataItem.id : null));
      formattedData.push({
        name: itemName,
        value: dataItem.factValue,
        countryid: cid
      });
    }
  }

  // 如果原始数据中没有中国，但有香港或台湾数据，手动添加
  if (!chinaProcessed && maxChinaValue !== null) {
    formattedData.push({
      name: '中国',
      value: maxChinaValue,
      _chinaData: chinaTooltipData
    });
  }

  option = {
    timeline: {
      axisType: 'category',
      orient: 'vertical',
      autoPlay: false,
      inverse: true,
      playInterval: 5000,
      left: null,
      right: -105,
      top: 20,
      bottom: 20,
      width: 46,
      data: []
    },
    baseOption: {
      visualMap: {
        min: min,
        max: max,
        padding: [0, 0, 0, 50],
        text: ["High", "Low"],
        realtime: false,
        calculable: true,
        inRange: {
          color: ['#5d5d5d', '#a8062c', '#d46f2e', '#d5b719', '#9cd634']
        }
      },
      series: [{
        type: 'map',
        map: 'world',
        roam: true,
        scaleLimit: {
          min: 1,
          max: 2
        },
        itemStyle: {
          emphasis: {
            label: {
              show: false
            }
          }
        },
        nameMap: nameMap,
        data: formattedData
      }]
    },
    options: [{
      title: {
        text: '资料来源：世界银行',
        bottom: 15,
        right: 30,
        textStyle: {
          color: '#2c3e50',
          fontSize: 14,
          fontWeight: 'normal',
        }
      },
      backgroundColor: '#f8f8f8',
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          // 中国特殊 tooltip
          if (params.data && params.data._chinaData) {
            var d = params.data._chinaData;
            var html = '<div style="font-weight:bold;margin-bottom:5px;">中国</div>';

            if (d.hasMainland && d.mainland !== null) {
              html += '中国内地 : ' + (Math.round(d.mainland * 100) / 100) + '<br/>';
            } else {
              html += '中国内地 : 暂无数据<br/>';
            }

            if (d.hongkong !== null) {
              html += '中国香港特区 : ' + (Math.round(d.hongkong * 100) / 100) + '<br/>';
            } else {
              html += '中国香港特区 : 暂无数据<br/>';
            }

            if (d.taiwan !== null) {
              html += '中国台湾地区 : ' + (Math.round(d.taiwan * 100) / 100);
            } else {
              html += '中国台湾地区 : 暂无数据';
            }

            return html;
          }

          // 其他国家
          if (params.value !== undefined && params.value !== null && params.value !== '' && !isNaN(params.value)) {
            return params.name + "<br/>总得分 : " + (Math.round(params.value * 100) / 100);
          }

          // 没有数据：只显示国家名
          return params.name;
        }
      },
      series: [{
        type: 'map',
        map: 'world',
        roam: true,
        data: formattedData,
        nameMap: nameMap,
        selectedMode: false
      }]
    }]
  };

  if (option && typeof option === "object") {
    Businessmap.setOption(option, true);
  }

  // ========== 点击跳转事件 ==========
  // 安全地移除旧事件
  try {
    Businessmap.off('click');
  } catch (e) {
    // 如果 off 方法不存在或出错，忽略
  }

  Businessmap.on('click', function (params) {
    // 调试日志（开发时可打开）
    // console.log('地图点击:', params.name, 'data:', params.data, 'value:', params.value);

    // 中国不跳转
    if (params.data && params.data._chinaData) {
      return;
    }

    // 没有数据的国家不跳转
    if (params.value === undefined || params.value === null || params.value === '') {
      return;
    }

    // 有数据的国家跳转
    if (params.data && params.data.countryid !== undefined && params.data.countryid !== null) {
      var url = window.location.origin + window.location.search +'#/db/economy?countryid=' + params.data.countryid;
      // 尝试新标签页打开
      var newWindow = window.open(url, '_blank');
      // 如果被拦截，使用当前页跳转
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        window.location.href = url;
      }
    }
  });
}